<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark">
        <p>{{ regulations.laws }}</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="dat">
          <div class="paging">
            时间范围:
            <el-date-picker
              popper-class="timeclass"
              v-model="tiemSta"
              type="date"
              placeholder="开始时间"
              @change="timeStaChange()"
            >
            </el-date-picker>
            至
            <el-date-picker
              popper-class="timeclass"
              v-model="timeEnd"
              type="date"
              placeholder="结束时间"
              @change="timeEndChange()"
            >
            </el-date-picker>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              prop="id"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="notice_title"
              label="通知标题"
              min-width="570px"
            >
              <template slot-scope="scope">
                               
                <span
                  style="
                    color: #4b74ff;
                    text-decoration: underline;
                    font-size: 12px;
                    cursor: pointer;
                  "
                  @click="TZ(scope.row.notice_title)"
                  type="text"
                  >{{ scope.row.notice_title }}</span
                >
                             
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="pub_time"
              label="发布时间"
              min-width="430px"
            >
              <template slot-scope="scope">{{
                scope.row.pub_time | formatDate
              }}</template>
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
        :title="dialogtitle"
        :visible.sync="centerDialogVisible"
        style="width:640px,height:400px"
        center
      >
        <el-card class="card">
          <span class="spp" v-html="dialogList"></span>
          <div class="bdk" v-html="dialogGuo"></div>
          <div class="bdk">
            {{ dialogTime | formatDate }}
          </div>
        </el-card>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>
import { URL_CRBNOTICEMAIN_FIND } from "../../utils/api";
import util from "../../utils/util";
import { frontHeater } from "../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "系统通知",
      },
      //   开始时间
      tiemSta: null,
      // 结束时间
      timeEnd: null,
      //   搜索
      searchOn: null,
      legalForms: [],
      dialogtitle: "",
      dialogList: "",
      dialogGuo: "",
      dialogTime: "",
      // 前往页数
      currentPage: 1,
      pagesize: 10,
      // 总条数
      total: 100,
      centerDialogVisible: false,
      bug: "1",
    };
  },
  computed: {},
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  methods: {
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },
    getList() {
      let result = frontHeater(["title"], [""]);
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        starttime: this.tiemSta,
        endtime: this.timeEnd,
        title: "",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["title"] = "";
      this.$http.post(Url + URL_CRBNOTICEMAIN_FIND, params).then((res) => {
        if (res.status == 200) {
          this.legalForms = res.data;
          this.total = res.data.length;
        }
      });
    },
    getTitleList(e) {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosOne");
      let params = {
        title: e,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.post(Url + URL_CRBNOTICEMAIN_FIND, params).then((res) => {
        if (res.status == 200) {
          this.dialogtitle = res.data[0].notice_title.replace(
            /\^p|\^P/g,
            "<br/>"
          );
          this.dialogList = res.data[0].notice_content.replace(
            /\^p|\^P/g,
            "<br/>"
          );
          this.dialogGuo = res.data[0].pub_organization.replace(
            /\^p|\^P/g,
            "<br/>"
          );
          this.dialogTime = res.data[0].pub_time.replace(/\^p|\^P/g, "<br/>");
        }
      });
    },
    TZ(val) {
      this.getTitleList(val);
      this.centerDialogVisible = true;
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.tiemSta = null;
      this.timeEnd = null;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },
    timeStaChange() {
      this.getList();
    },
    timeEndChange() {
      this.getList();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/theme";
@import "../../styles/comSty";
p {
  font-size: 22px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}

/deep/.paging .el-input {
  font-size: 12px;
  width: 150px;
}
.dat {
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
}

.card {
  padding: 10px 20px;
  .spp {
    text-indent: 2rem;
  }
  .bdk {
    margin: 20px 0;
  }
}
</style>